module.exports = __webpack_public_path__ + "static/img/20002 (1).6e64234.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20002 (1).webp
// module id = IJa5
// module chunks = 14